// eslint-disable-next-line
export const getLastAppliedFilters = (state) =>
  state.getIn(['mobile', 'lastAppliedFilters']);
